// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btnGoTop[data-v-e3e49eba]{position:fixed;bottom:20px;right:30px;z-index:99;font-size:18px;border:none;outline:none;background-color:#31a35e;color:#fff;cursor:pointer;padding:10px;padding-bottom:7px;border-radius:4px}.btnGoTop[data-v-e3e49eba]:hover{background-color:#555}", ""]);
// Exports
module.exports = exports;
